/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfCategoryTreeItemDto } from '../../models/paginated-dto-of-category-tree-item-dto';

export interface GetCategoriesTree$Params {
}

export function getCategoriesTree(http: HttpClient, rootUrl: string, params?: GetCategoriesTree$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfCategoryTreeItemDto>> {
  const rb = new RequestBuilder(rootUrl, getCategoriesTree.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfCategoryTreeItemDto>;
    })
  );
}

getCategoriesTree.PATH = '/api/v1/categories/tree';
